<template>
  <h1>{{ text }}</h1>
</template>

<script>
export default {
  name: "Heading",
  props: ["text"]
};
</script>

<style lang="stylus" scoped>
h1
  font-family: "montserrat"
  font-weight: bold
  fluid font-size 28 20
  color: #001249
  margin: 0px
</style>
